import styled from "@emotion/styled";

import { fontRobotoCondensed, theme } from "shared/lib/styles";

export const OuterContainer = styled.div`
  inline-size: 100%;
  block-size: 100%;

  ${theme.breakpoints.only("mobile")} {
    position: sticky;
    inset-block-start: 46px;
    z-index: 999;

    inline-size: 100vw;
    margin-inline-start: -20px;
    padding-block: 12px 4px;

    background-color: #ffffff;
  }
`;

export const Container = styled.div`
  position: sticky;

  display: flex;
  row-gap: 10px;

  background-color: #ffffff;

  overflow-x: scroll;
  scrollbar-width: none;
  overscroll-behavior: none;

  ::-webkit-scrollbar {
    display: none;
  }

  ${theme.breakpoints.up("tablet")} {
    inset-block-start: 81px;

    flex-direction: column;

    inline-size: 160px;
  }

  ${theme.breakpoints.up("desktop")} {
    inset-block-start: 87px;
  }
`;

export const FilterHeader = styled.div`
  margin-block-start: 20px;

  color: #000000;
  font-weight: 700;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  line-height: 100%;

  ${theme.breakpoints.only("mobile")} {
    display: none;
  }
`;

type FilterChipProps = {
  $isActive: boolean;
};

export const FilterChip = styled.div<FilterChipProps>`
  display: block;

  inline-size: fit-content;
  padding-block: 10px;
  padding-inline: 8px;

  color: #ffffff;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: 100%;
  white-space: nowrap;

  border-radius: 4px;

  background-color: ${props => (props.$isActive ? "#000000" : "#BBBBBB")};

  cursor: pointer;

  ${theme.breakpoints.only("mobile")} {
    :not(:last-of-type) {
      margin-inline-end: 10px;
    }

    :first-of-type {
      margin-inline-start: 20px;
    }

    :last-of-type {
      margin-inline-end: 20px;
    }
  }

  ${theme.breakpoints.up("tablet")} {
    padding-block: 6px;
    padding-inline: 8px;

    font-size: 18px;
  }
`;
